export default [
	'Yes',
	'No'
];
